"use client";

import Features from "@/components/features-vertical";
import Section from "@/components/section";
import { Icons } from "@/components/icons";
import { useNextSectionScroll } from "@/lib/hooks/use-next-section-scroll";
import { FileSearch, Lightbulb, Puzzle, TrendingUp } from "lucide-react";
import { useTranslations } from "@/lib/hooks/use-translations";

// Importiere die Bilder direkt
import howItWorks1 from "@/assets/images/how_it_works_01.png";
import howItWorks2 from "@/assets/images/how_it_works_02.png";
import howItWorks3 from "@/assets/images/how_it_works_03.png";
import howItWorks4 from "@/assets/images/how_it_works_04.png";

const iconMap = {
  1: FileSearch,
  2: Lightbulb,
  3: Puzzle,
  4: TrendingUp
};

const imageMap = {
  1: howItWorks1.src,
  2: howItWorks2.src,
  3: howItWorks3.src,
  4: howItWorks4.src
};

export default function HowItWorks({ locale = "en" }: { locale?: "de" | "en" | "zh-CN" } = {}) {
  const handleNextSection = useNextSectionScroll("how-it-works");
  const { t, locale: currentLocale } = useTranslations();

  const getContactUrl = () => {
    const localeToUse = currentLocale || locale;
    if (localeToUse === "de") return "/de/kontakt";
    if (localeToUse === "zh-CN") return "/zh-CN/contact";
    return "/contact";
  };

  const steps = t<Array<{ id: number; title: string; content: string }>>('pages.home.how-it-works.steps');

  const data = steps.map(step => ({
    ...step,
    image: imageMap[step.id as keyof typeof imageMap],
    icon: (() => {
      const Icon = iconMap[step.id as keyof typeof iconMap];
      return <Icon className="w-6 h-6 text-primary" />;
    })()
  }));

  return (
    <Section
      id="how-it-works"
      title={t('pages.home.how-it-works.title')}
      subtitle={t('pages.home.how-it-works.subtitle')}
      mainCta={{
        text: t('pages.home.hero.cta.getStarted'),
        href: getContactUrl(),
        icon: <Icons.logoIcon className="h-6 w-6" />
      }}
      secondaryCta={{
        text: t('pages.home.hero.cta.readMore'),
        onClick: handleNextSection
      }}
    >
      <Features data={data} />
    </Section>
  );
}
